<template>
<div class="odr-split-line" :class="{'odr-split-line_no-margin': noMargins === 'true'}">
    <slot> </slot>
</div>
</template>

<script>
import '../styles/split-line.scss'

export default {
    props: {
        noMargins: {
            type: String,
            _descr: 'remove margins',
        },
    },
}
</script>
